/**
 * @file paddlehub demo 词法分析入口
 * @author FengGuang(fengguang01@baidu.com)
 */

import TextDemo from './TextDemo';
import './style.less';

export default TextDemo;
